export const getclassesIrcAdmin = (state) => state.classesIrcAdmin.lista
export const getIsCarregandoListaclassesIrcAdmin =
  (state) => state.classesIrcAdmin.isCarregandoLista
export const getIsSavingClassesIrcAdmin = (state) => state.classesIrcAdmin.isSaving
export const getIsUpdatingClassesIrcAdmin = (state) => state.classesIrcAdmin.isUpdate
